import {
  FIELD_BASE,
  FIELD_DISABLED,
  FIELD_ERROR,
  FIELD_LABEL,
  fieldState,
} from "./formFieldStyles";

const FormInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = "text",
  required = false,
  placeholder,
  disabled = false,
}) => (
  <div>
    {label && (
      <label htmlFor={name} className={FIELD_LABEL}>
        {label} {required && <span className="text-danger-500">*</span>}
      </label>
    )}

    <input
      id={name}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      className={`${FIELD_BASE} ${fieldState(error)} ${
        disabled ? FIELD_DISABLED : "text-gray-900"
      }`}
    />

    {error && <p className={FIELD_ERROR}>{error}</p>}
  </div>
);

export default FormInput;
